// loads scripts that need to be on page - every entrypoint should import this!
import './kickstart';

// Data
import { dateParser } from './utils/d3-utils';
import { loadJsonScript } from './utils/load-json-script';

// data for arrow map
const countyElectionsData = loadJsonScript('counties-elections-map-data');

// testing the unemployment map format

import CountiesMapDashboard from './components/CountiesMapDashboard.svelte';

new CountiesMapDashboard({
  target: document.getElementById('counties-map'),
  props: { data: countyElectionsData },
});

// Stacked bar chart for party preference

import StackedBar from './components/StackedBar.svelte';
import StackedBarMultiples from './components/StackedBarMultiples.svelte';

const laGovRaceCompare = loadJsonScript('newsom-davis-la-data');
laGovRaceCompare.forEach((element) => {
  const statewidePartyPrefTarget = document.getElementById(
    `statewide-party-chart-${element.year}`
  );

  const laGovRaceCompareTarget = document.getElementById(
    'newsom-davis-la-chart'
  );

  new StackedBar({
    target: laGovRaceCompareTarget,
    props: {
      width: laGovRaceCompareTarget.offsetWidth,
      height: 35,
      labelHeight: 20,
      labelClass: 'party-election-label',
      title: 'donkey',
      titleClass: 'normal',
      data: element,
      yLabel: element.year,
      attrs: [
        {
          key: 'd_pct',
          name: 'Democratic',
          color: '#1d81c5',
        },
        {
          key: 'r_pct',
          name: 'Republican',
          color: '#cc3d3d',
        },
      ],
    },
  });
});

const statewidePartyPrefData = loadJsonScript('statewide-party-data');

statewidePartyPrefData.forEach((element) => {
  const statewidePartyPrefTarget = document.getElementById(
    `statewide-party-chart-${element.year}`
  );

  new StackedBar({
    target: statewidePartyPrefTarget,
    props: {
      width: statewidePartyPrefTarget.offsetWidth,
      height: 35,
      labelHeight: 20,
      labelClass: 'party-pref-bar-label-statewide',
      title: 'foobar',
      titleClass: 'normal',
      data: element,
      yLabel: element.year,
      attrs: [
        {
          key: 'democratic_pct',
          name: 'Democratic',
          color: '#1d81c5',
        },
        {
          key: 'noparty_other_pct',
          name: 'No Party/Other',
          color: '#999999',
        },
        {
          key: 'republican_pct',
          name: 'Republican',
          color: '#cc3d3d',
        },
      ],
    },
  });
});

// Read in 2003 vs. 2020 party preference data for each of California’s 58 counties
// Structured as a dictionary-like object.
// The keys are county names.
// The values are lists with two data dicts, one for each election year.
const countyPartyPrefData = loadJsonScript('county-party-data');

for (const [regionName, countyDataDict] of Object.entries(
  countyPartyPrefData
)) {
  const partyChartID = `county-party-chart-${regionName
    .replaceAll(' ', '_')
    .toLowerCase()}`;
  const partyChartsTarget = document.getElementById(
    `county-party-chart-${regionName.replaceAll(' ', '_').toLowerCase()}`
  );

  // Loop through each county, one by one
  let i = 0;
  for (const [countyName, countyDataList] of Object.entries(countyDataDict)) {
    // Up the iterator
    i += 1;

    // Make a new parent div for each county
    const countyChartTarget = document.createElement('div');

    // Set the id for the element
    countyChartTarget.setAttribute(
      'id',
      `county-party-chart-${countyName.toLowerCase()}`
    );

    // Give it a special class
    countyChartTarget.classList.add('mini-multiples');

    const chartTitleWrapper = document.createElement('div');
    chartTitleWrapper.classList.add('chart-title-wrapper');

    const chartAnnoWrapperParties = document.createElement('div');
    chartAnnoWrapperParties.classList.add('chart-wrapper-parties');

    // Add the county title to the container
    const countyChartTitle = document.createElement('b');

    // Fill it with the county name
    countyChartTitle.innerHTML = countyName;

    // Give it a special class
    countyChartTitle.classList.add('mini-counties');

    const chartAnnoDem = document.createElement('div');
    chartAnnoDem.classList.add('mini-anno-dem');
    chartAnnoDem.innerHTML =
      (+(
        countyDataList[1].democratic_pct - countyDataList[0].democratic_pct
      ).toFixed(1) < 0
        ? ''
        : '+') +
      +(
        countyDataList[1].democratic_pct - countyDataList[0].democratic_pct
      ).toFixed(1);

    const chartAnnoRep = document.createElement('div');

    chartAnnoRep.classList.add('mini-anno-rep');
    chartAnnoRep.innerHTML =
      (+(
        countyDataList[1].republican_pct - countyDataList[0].republican_pct
      ).toFixed(1) < 0
        ? ''
        : '+') +
      +(
        countyDataList[1].republican_pct - countyDataList[0].republican_pct
      ).toFixed(1);

    // Add the title tag to the parent div
    chartTitleWrapper.appendChild(countyChartTitle);
    countyChartTarget.appendChild(chartTitleWrapper);

    // Add the div to the container
    partyChartsTarget.appendChild(countyChartTarget);

    chartAnnoWrapperParties.appendChild(chartAnnoRep);
    chartAnnoWrapperParties.appendChild(chartAnnoDem);

    // Loop through the two data elements in the county's list
    countyDataList.forEach((d) => {
      // Create the chart
      new StackedBarMultiples({
        target: countyChartTarget,
        props: {
          width: 150,
          height: 25,
          labelHeight: 20,
          labelClass: 'party-pref-bar-label',
          data: d,
          yLabel: i == 1 ? d.year : null,
          attrs: [
            {
              key: 'democratic_pct',
              name: 'Democratic',
              color: '#1d81c5',
            },
            {
              key: 'noparty_other_pct',
              name: 'No Party/Other',
              color: '#999999',
            },
            {
              key: 'republican_pct',
              name: 'Republican',
              color: '#cc3d3d',
            },
          ],
        },
      });
    });
    countyChartTarget.appendChild(chartAnnoWrapperParties);
  }
}
